interface AdPoolItem {
  _id: string
  [key: string]: any
}

export const calculateNextAdByPool = <T extends AdPoolItem>(
  adPool: T[],
  currentAdIndex: number | string | null = null,
): T | null => {
  if (!adPool?.length) return null

  let nextAdIndex = Math.floor(Math.random() * adPool.length)

  const parsed = parseInt(String(currentAdIndex))
  if (!isNaN(parsed)) {
    const isIndexLastIndex = parsed === (adPool.length - 1)
    const incrementedAdIndex = isIndexLastIndex ? 0 : (parsed + 1)
    nextAdIndex = incrementedAdIndex
  }
  return adPool[nextAdIndex]
}

interface ArrayItemWithId {
  id: string | number
  [key: string]: any
}

export const replaceObjectInArrayById = (
  array: ArrayItemWithId[],
  id: string | number,
  newValue: ArrayItemWithId,
): ArrayItemWithId[] => {
  const foundIndex = array.findIndex(item => item.id === id)
  if (foundIndex !== -1) {
    array[foundIndex] = newValue
  }
  return array
}
